/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Navigate, useParams } from 'react-router-dom';

import { useGetFootprintById } from '../../hooks/api/footprints';
import { CREATION_METHOD, FootPrintStatus } from '../../shared/interfaces/IFootprint';
import PcfWizard from '../product-details/components/product-tab-view/tabs/pcf-tab/components/pcf-wizard/PcfWizard';
import AdditionalDetailsSection from './components/additional-details-section/AdditionalDetailsSection';
import EmissionsSection from './components/emissions-section/EmissionsSection';
import GoBackToPcfListButton from './components/go-back-to-pcf-list-button/GoBackToPcfListButton';
import PcfGeneralDetailsSection from './components/pcf-general-details-section/PcfGeneralDetailsSection';
import ProductCarbonFootprintSection from './components/product-carbon-footprint-section/ProductCarbonFootprintSection';

const FootprintDetailsPage = (): JSX.Element => {
  const { productId, footprintId, componentId } = useParams() as {
    productId: string;
    footprintId: string;
    componentId: string;
  };

  // Getting the footprint details
  const { data: footprintDetails, isError } = useGetFootprintById(Number(footprintId), {
    enabled: !!footprintId,
    retry: 0,
  });

  const footprintDetailsContent = (
    <div className='flex w-full justify-content-center'>
      <div className='flex flex-column gap-4 w-full md:w-10 lg:w-8 xl:w-7'>
        <GoBackToPcfListButton
          url={componentId ? `/components/${componentId}/pcf` : `/products/${productId}/pcf`}
        />

        <ProductCarbonFootprintSection />

        <PcfGeneralDetailsSection />

        <EmissionsSection />

        <AdditionalDetailsSection />
      </div>
    </div>
  );

  // Determine content based on pcf calculation method
  const renderContent = (): JSX.Element => {
    if (
      footprintDetails?.creation_method === CREATION_METHOD.CALCULATION &&
      footprintDetails?.status === FootPrintStatus.DRAFT
    ) {
      return <PcfWizard />;
    }

    // Default is footprint details
    return footprintDetailsContent;
  };

  // If footprint details not found then navigate to 404 page
  if (isError) {
    return <Navigate to='/404' />;
  }

  return renderContent();
};

export default FootprintDetailsPage;
